/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiGroupHoursFromJSON(json) {
    return StreemApiGroupHoursFromJSONTyped(json, false);
}
export function StreemApiGroupHoursFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'day': !exists(json, 'day') ? undefined : json['day'],
        'startTimeUtc': !exists(json, 'start_time_utc') ? undefined : json['start_time_utc'],
        'endTimeUtc': !exists(json, 'end_time_utc') ? undefined : json['end_time_utc'],
        'timeZoneId': !exists(json, 'time_zone_id') ? undefined : json['time_zone_id'],
    };
}
export function StreemApiGroupHoursToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'day': value.day,
        'start_time_utc': value.startTimeUtc,
        'end_time_utc': value.endTimeUtc,
        'time_zone_id': value.timeZoneId,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiGroupHoursDay;
(function (StreemApiGroupHoursDay) {
    StreemApiGroupHoursDay["FRIDAY"] = "DAYS_OF_WEEK_FRIDAY";
    StreemApiGroupHoursDay["INVALID"] = "DAYS_OF_WEEK_INVALID";
    StreemApiGroupHoursDay["MONDAY"] = "DAYS_OF_WEEK_MONDAY";
    StreemApiGroupHoursDay["SATURDAY"] = "DAYS_OF_WEEK_SATURDAY";
    StreemApiGroupHoursDay["SUNDAY"] = "DAYS_OF_WEEK_SUNDAY";
    StreemApiGroupHoursDay["THURSDAY"] = "DAYS_OF_WEEK_THURSDAY";
    StreemApiGroupHoursDay["TUESDAY"] = "DAYS_OF_WEEK_TUESDAY";
    StreemApiGroupHoursDay["WEDNESDAY"] = "DAYS_OF_WEEK_WEDNESDAY";
})(StreemApiGroupHoursDay || (StreemApiGroupHoursDay = {}));
//# sourceMappingURL=StreemApiGroupHours.js.map